module.exports = __webpack_public_path__ + "media/3_23.40b3d30d.wav";